import { render, staticRenderFns } from "./AddCampaignDialog.vue?vue&type=template&id=ea9b2260&scoped=true&"
import script from "./AddCampaignDialog.vue?vue&type=script&lang=js&"
export * from "./AddCampaignDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaignDialog.vue?vue&type=style&index=0&id=ea9b2260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9b2260",
  null
  
)

/* custom blocks */
import block0 from "./AddCampaignDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports